import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import FormLabel from '@mui/material/FormLabel'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Checkbox from '@mui/material/Checkbox'
import FormHelperText from '@mui/material/FormHelperText'
import ListItemText from '@mui/material/ListItemText'
import Grid from '@mui/material/Grid'
import { Alert, AlertTitle, Box, Collapse, Paper, Snackbar, Typography } from '@mui/material'

// Integraciones externas disponibles (archivos en device/routes/api/*_ext).
// Mantener en sync si se agregan nuevos archivos de integracion.
const OPCIONES_VALIDAR_API  = ["walli"]
const OPCIONES_REPORTAR_API = ["flexipay", "uplifex", "walli"]

const session = require('../../config/session')
const RestTunel = require('../../libs/rest_tunnel')

class UsuariosCrearPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
          entidades: [], 
          txtSerial: "",
          txtCodigo: "",
          txtAlias: "",
          txtDireccion: "",
          txtValidarApi: "",
          txtReportarApi: "",
          txtEmailOperativo: "",
          txtEmailSeguridad: "",
          cmbEntidades: 0,
          ticketPorUsuario: 0,
          mostrarResumenDeposito: "Si",
          idNuevoCajero: 0,

          mostrarAlerta: false,
          mensajeAlerta: '',
          severidadAlerta: 'info'
        }

    }

    validarCorreos = (texto) => {
      if (!texto) return false;

      const correos = texto.split(';').map(c => c.trim()).filter(Boolean);

      if (correos.length === 0) return false;

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      return correos.every(c => emailRegex.test(c));
    };


    normalizarEmails = (value) => {
      if (!value) return "";

      if (Array.isArray(value)) {
        return value.join('; ');
      }

      try {
        const parsed = JSON.parse(value);
        if (Array.isArray(parsed)) {
          return parsed.join('; ');
        }
      } catch (e) {}

      return value;
    };

    handleCloseAlert= (event, reason) => {
      if (reason === 'clickaway') {
        return; // Evitar que se cierre si el usuario hace clic fuera
      }
      this.setState({ mostrarAlerta: false })
    }

    onChangetxtSerial = (event) => {
      const serial = event.target.value.toString()
      this.setState({txtSerial: serial})
    }

    onChangetxtCodigo = (event) => {
        const codigo = event.target.value.toString()
        this.setState({txtCodigo: codigo})
    }

    onChangetxtAlias = (event) => {
        const alias = event.target.value.toString()
        this.setState({txtAlias: alias})
    }

    onChangecmbEntidades = (event) => {
      const entidad = event.target.value
      this.setState({cmbEntidades: entidad})
    }

    onChangetxtDireccion = (event) => {
        const direccion = event.target.value.toString()
        this.setState({txtDireccion: direccion})
    }

    onChangetxtValidarApi = (event) => {
        const validarApi = event.target.value.toString()
        this.setState({txtValidarApi: validarApi})
    }

    onChangetxtReportarApi = (event) => {
        // Multi-select: value es un array -> se guarda como string separada por ';'
        const val = event.target.value
        const reportarApi = Array.isArray(val) ? val.filter(Boolean).join(';') : val.toString()
        this.setState({txtReportarApi: reportarApi})
    }

    onChangeTicketPorUsuario = (event) => {
        this.setState({ticketPorUsuario: parseInt(event.target.value, 10) || 0})
    }

    onChangeMostrarResumenDeposito = (event) => {
        this.setState({mostrarResumenDeposito: event.target.value})
    }

    onChangetxtEmailOperativo = (event) => {
      const value = event.target.value;
      this.setState({txtEmailOperativo: value});

      if (!this.validarCorreos(value)) {
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: 'Ingrese correo valido (Nota: use ; para separar)',
          severidadAlerta: 'warning'
        });
      }
    }

    onChangetxtEmailSeguridad = (event) => {
      const value = event.target.value;
      this.setState({txtEmailSeguridad: value});

      if (!this.validarCorreos(value)) {
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: 'Ingrese correo valido (Nota: use ; para separar)',
          severidadAlerta: 'warning'
        });
      }
    }

    componentDidMount() {
      this.queryEntidades()
    }

    btnAgregarCajeroClick = () => {
        console.log('Agregando cajero....')

        var continuar = true
        var mensajeError = "Error:\n"

        const {txtEmailOperativo, txtEmailSeguridad} = this.state;

        if (
        !this.validarCorreos(txtEmailOperativo)||
        !this.validarCorreos(txtEmailSeguridad)
        ) {
          this.setState({
            mostrarAlerta: true,
            mensajeAlerta: 'Ingrese todos los correos',
            severidadAlerta: 'warning'
          });
          return;
        }

        var serial = this.state.txtSerial
        var codigo = this.state.txtCodigo
        var alias = this.state.txtAlias
        var entidad = this.state.cmbEntidades
        var direccion = this.state.txtDireccion


        serial = serial.trim()
        codigo = codigo.trim()
        alias = alias.trim()
        direccion = direccion.trim()
        
        if(serial === '') {
          continuar = false
          mensajeError += " * Debe ingresar el serial.\n"
        }

        if(codigo === '') {
          continuar = false
          mensajeError += " * Debe ingresar el código.\n"
        }

        if(alias === '') {
          continuar = false
          mensajeError += " * Debe ingresar el alias.\n"
        }


        if(direccion === '') {
          continuar = false
          mensajeError += " * Debe ingresar la dirección/ubicación.\n"
        }

        if(entidad === 0) {
          continuar = false
          mensajeError += " * Debe seleccionar una entidad.\n"
        }

    
        if(continuar) {
			
			console.log('Consultando grupos....')
		    
		    var restArgs = {
		      method: 'PUT',
		      headers: 'JSON',
		      body: {
				    serial: serial,
	                codigo: codigo,
	                alias: alias,
                  email_operativo: txtEmailOperativo,
                  email_seguridad: txtEmailSeguridad,
	                direccion: direccion,
	                validar_api_depositante: this.state.txtValidarApi.trim(),
	                reportar_api_transaccion: this.state.txtReportarApi.trim(),
	                ticket_por_usuario: this.state.ticketPorUsuario,
	                mostrar_resumen_deposito: this.state.mostrarResumenDeposito,
	                entidad: entidad
			  },
		      url: process.env.REACT_APP_URL_BACKEND + '/cajeros/new'
		    }
		
		    RestTunel.makePetition(restArgs,(err, data) => {
		      if(err) {
		        //console.log('Error respuesta insertar cajero')
                this.setState({
                  mensajeError: data.message,
                  mostrarAlerta: true,
                  mensajeAlerta: data.message,
                  severidadAlerta: 'error'
                })
                //alert("Error: Se produjo un error creando el cajero.")
		      } else {
		        //onsole.log('Cajero creado')
                //alert("Nuevo cajero creado")
                this.setState({
                  idNuevoCajero: data,
                  mostrarAlerta: true,
                  mensajeAlerta: 'Nuevo cajero creado',
                  severidadAlerta: 'success',
                }, ()=>{
                  this.btnLimpiarClick2();
                })
		      }
		    })
	    }else{
        this.setState({
          mostrarAlerta: true,
          mensajeAlerta: mensajeError,
          severidadAlerta: 'error'
        })
      }
        
    }

    

    btnLimpiarClick = () => {
      this.setState({
        txtSerial: "",
        txtCodigo: "",
        txtAlias: "",
        txtDireccion: "",
        txtValidarApi: "",
        txtReportarApi: "",
        ticketPorUsuario: 0,
        mostrarResumenDeposito: "Si",
        txtEmailOperativo: "",
        txtEmailSeguridad: "",
        cmbEntidades: 0,
        idNuevoCajero: 0
      })
    }

    btnLimpiarClick2 = () => {
      this.setState({
        txtSerial: "",
        txtCodigo: "",
        txtAlias: "",
        txtDireccion: "",
        txtValidarApi: "",
        txtReportarApi: "",
        ticketPorUsuario: 0,
        mostrarResumenDeposito: "Si",
        txtEmailOperativo: "",
        txtEmailSeguridad: "",
        cmbEntidades: 0
      })
    }

    queryEntidades() {
      // console.log('Consultando entidades....')
    
	    var restArgs = {
	      method: 'POST',
	      headers: 'JSON',
	      body: {},
	      url: process.env.REACT_APP_URL_BACKEND + '/entidades/usuario/list'
	    }
	
	    RestTunel.makePetition(restArgs,(err, data) => {
	      if(err) {
	        //alert("Error consultando entidaddes")
	        //console.log('Error respuesta consultando entidades')
	        this.setState({
            entidades: [],
            mensajeError: data.message,
            mostrarAlerta: true,
            mensajeAlerta: 'Error consultando entidaddes',
            severidadAlerta: 'error'
	        })
	      } else {
	        //console.log('Entidades consultadas')
            this.setState({
              entidades: data,
              mostrarAlerta: true,
              
              })
	      }
	    })
    }

    render() {
        return(

        <Box>
          <Typography gutterBottom variant="h5" component="div" sx={{ marginBottom: 2 }}>
            Crear Cajero
          </Typography>

            <Paper elevation={16}>
                <Card>
                    <CardContent>
                        <form>
                            <FormLabel>Información cajero</FormLabel>
                            <br />
                            <Grid container spacing={2} rowSpacing={2}>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <TextField
                                  label="Serial"
                                  id="outlined-basic"
                                  variant="outlined"
                                  value={this.state.txtSerial}
                                  onChange={this.onChangetxtSerial}
                                  helperText="No se podrá cambiar después de crear (no editable)"
                                  fullWidth
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <TextField
                                  label="Código"
                                  id="outlined-basic"
                                  variant="outlined"
                                  value={this.state.txtCodigo}
                                  onChange={this.onChangetxtCodigo}
                                  fullWidth
                                  />
                                </FormControl>
                              </Grid>   
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <TextField
                                  label="Alias"
                                  id="outlined-basic"
                                  variant="outlined"
                                  value={this.state.txtAlias}
                                  onChange={this.onChangetxtAlias}
                                  fullWidth
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                    <TextField
                                    label="Dirección/Ubicación"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtDireccion}
                                    onChange={this.onChangetxtDireccion}
                                    fullWidth
                                  />
                               </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth>
                                    <InputLabel>Validar depositantes por API</InputLabel>
                                    <Select
                                      label="Validar depositantes por API"
                                      value={this.state.txtValidarApi}
                                      onChange={this.onChangetxtValidarApi}
                                    >
                                      <MenuItem value=""><em>— Validación local —</em></MenuItem>
                                      {OPCIONES_VALIDAR_API.map(op => (
                                        <MenuItem key={op} value={op}>{op}</MenuItem>
                                      ))}
                                    </Select>
                                    <FormHelperText>Vacío = validación local.</FormHelperText>
                               </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth>
                                    <InputLabel>Reportar transacción por API</InputLabel>
                                    <Select
                                      multiple
                                      label="Reportar transacción por API"
                                      value={this.state.txtReportarApi ? this.state.txtReportarApi.split(';').filter(Boolean) : []}
                                      onChange={this.onChangetxtReportarApi}
                                      renderValue={(selected) => selected.join(', ')}
                                    >
                                      {OPCIONES_REPORTAR_API.map(op => (
                                        <MenuItem key={op} value={op}>
                                          <Checkbox checked={(this.state.txtReportarApi || "").split(';').filter(Boolean).indexOf(op) > -1} />
                                          <ListItemText primary={op} />
                                        </MenuItem>
                                      ))}
                                    </Select>
                                    <FormHelperText>Vacío = solo reporta a nuestro servidor. Puede elegir varios.</FormHelperText>
                               </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                    <TextField
                                    label="Correo Operativo"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtEmailOperativo}
                                    onChange={this.onChangetxtEmailOperativo}
                                    type='text'
                                    fullWidth
                                  />
                               </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                    <TextField
                                    label="Correo Seguridad"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={this.state.txtEmailSeguridad}
                                    onChange={this.onChangetxtEmailSeguridad}
                                    type='text'
                                    fullWidth
                                  />
                               </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <InputLabel>Entidad</InputLabel>
                                  <Select
                                    label="Entidad"
                                    value={this.state.cmbEntidades}
                                    defaultValue={0}
                                    onChange={this.onChangecmbEntidades}>
                                    <MenuItem value={0}>-- Seleccione entidad --</MenuItem>
                                    {this.state.entidades.map(entidad => (
                                      <MenuItem key={entidad.id} value={entidad.id}>{entidad.nombre}</MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <InputLabel>Mostrar resumen de deposito</InputLabel>
                                  <Select
                                    label="Mostrar resumen de deposito"
                                    value={this.state.mostrarResumenDeposito}
                                    defaultValue={"Si"}
                                    onChange={this.onChangeMostrarResumenDeposito}>
                                    <MenuItem value={"Si"}>Si</MenuItem>
                                    <MenuItem value={"No"}>No</MenuItem>
                                  </Select>
                                  <FormHelperText>No = muestra "GRACIAS POR SU DEPOSITO" en vez del resumen.</FormHelperText>
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <FormControl fullWidth component="fieldset">
                                  <InputLabel>Ticket por deposito</InputLabel>
                                  <Select
                                    label="Ticket por deposito"
                                    value={this.state.ticketPorUsuario}
                                    defaultValue={0}
                                    onChange={this.onChangeTicketPorUsuario}>
                                    <MenuItem value={0}>0</MenuItem>
                                    <MenuItem value={1}>1</MenuItem>
                                    <MenuItem value={2}>2</MenuItem>
                                    <MenuItem value={3}>3</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                            </Grid>
                        </form>
                      </CardContent>
                      <CardActions>
                          <Button  variant="contained" onClick={this.btnAgregarCajeroClick} sx={{marginBottom:2, marginLeft: 1 }}>Crear Cajero</Button>
                          <Snackbar
                                            open={this.state.mostrarAlerta}
                                            onClose={this.handleCloseAlert}
                                            autoHideDuration={3000}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                            >
                                            <Collapse in={this.state.mostrarAlerta}>
                                                <Alert
                                                    severity={this.state.severidadAlerta}
                                                    onClose={this.handleCloseAlert}
                                                    sx={{ marginTop: 4, width:'100%'}}
                                                    >
                                                <AlertTitle>
                                                    {this.state.severidadAlerta.toUpperCase()}
                                                </AlertTitle>
                                                    {this.state.mensajeAlerta}
                                                </Alert>
                                            </Collapse>
                          </Snackbar> 
                          <Button  variant="contained" onClick={this.btnLimpiarClick} sx={{marginBottom:2, marginLeft: 1 }}>Limpiar</Button>
                          <Snackbar
                                            open={this.state.mostrarAlerta}
                                            onClose={this.handleCloseAlert}
                                            autoHideDuration={3000}
                                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                            >
                                            <Collapse in={this.state.mostrarAlerta}>
                                                <Alert
                                                    severity={this.state.severidadAlerta}
                                                    onClose={this.handleCloseAlert}
                                                    sx={{ marginTop: 4, width:'100%'}}
                                                    >
                                                <AlertTitle>
                                                    {this.state.severidadAlerta.toUpperCase()}
                                                </AlertTitle>
                                                    {this.state.mensajeAlerta}
                                                </Alert>
                                            </Collapse>
                          </Snackbar> 
                      </CardActions>
                </Card>
              
            </Paper>
                <br />
                { this.state.idNuevoCajero !== 0 &&
                  <Link to={{pathname: '/dashboard/cajeros/editar', state: {id_cajero: this.state.idNuevoCajero}}} style={{ textDecoration: 'none' }}><Button variant="contained" color="info">Configurar nuevo cajero</Button>
                  <Snackbar
                                    open={this.state.mostrarAlerta}
                                    onClose={this.handleCloseAlert}
                                    autoHideDuration={3000}
                                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                                    >
                                    <Collapse in={this.state.mostrarAlerta}>
                                      <Alert
                                          severity={this.state.severidadAlerta}
                                          onClose={this.handleCloseAlert}
                                          sx={{ marginTop: 4, width:'100%'}}
                                        >
                                          <AlertTitle>
                                            {this.state.severidadAlerta.toUpperCase()}
                                          </AlertTitle>
                                                        
                                          {this.state.mensajeAlerta}
                                      </Alert>
                                    </Collapse>
                  </Snackbar> 
                  </Link>
                }
          

        </Box>
        )
    }

}


export default UsuariosCrearPage